import { VehicleEntity } from '../api'
import { translateSfOpportunityFields, translateSfTypePickvalues, translateSfLeadSourcePickvalues } from './translations'
interface PrevPageOptions {
  accountId?: string;
  opportunityId?: string;
  vehicle?: VehicleEntity; // Updated to accept VehicleEntity
}


export const getPrevPage = (breadCrumbFrom: string, options: PrevPageOptions = {}) => {
  const { accountId, opportunityId, vehicle } = options;
  switch (breadCrumbFrom) {
    case 'account':
      return accountId ? `/my-accounts/${accountId}` : '/my-accounts';
    case 'opportunity':
      return opportunityId ? `/opportunities/${opportunityId}` : '/opportunities';
    default:
      return vehicle?.id ? `/details/${vehicle.id}` : '/details';
  }
};

export const dynamicTranslateOpportunityFields = (opportunityFieldsRes: any) => {
  let accTyps = opportunityFieldsRes.map(el => {
    return {
      label: translateSfOpportunityFields(el.label),
      name: el.name,
      picklistValues: el.picklistValues.map(picklist => {
        if (el.name === 'LeadSource') {
           return {
            ...picklist,
            label: translateSfLeadSourcePickvalues(picklist.label)
          }
        }
        if (el.label === 'Tipologia') {
          return {
            ...picklist,
            label: translateSfTypePickvalues(picklist.label)
          }
        } else {
          return picklist
        }
      })
    };
  });

  return accTyps
}

type DealerCommissionField = 'commissions' | 'provvigioniPassive';
type SegnalatoreCrossField = DealerCommissionField | 'provvigioniSegnalatore';

export const applySegnalatoreCrossUpdate = ({
  field,
  value,
  isMasterOrBackoffice,
  segnalatorePerc,
  setFieldValue,
}: {
  field: SegnalatoreCrossField;
  value: string;
  isMasterOrBackoffice: boolean;
  segnalatorePerc: string | number | null | undefined;
  setFieldValue: (name: string, val: any) => void;
}) => {
  if (segnalatorePerc === null || segnalatorePerc === undefined || segnalatorePerc === '') return;
  const perc = parseFloat(String(segnalatorePerc));
  if (isNaN(perc)) return;

  const dealerField: DealerCommissionField = isMasterOrBackoffice ? 'provvigioniPassive' : 'commissions';

  if (field === 'provvigioniSegnalatore') {
    if (perc === 0) {
      setFieldValue(dealerField, '');
      return;
    }
    const provvSegnalatore = parseFloat(value);
    const provvDealer = provvSegnalatore / (perc / 100);
    setFieldValue(dealerField, isNaN(provvDealer) ? '' : provvDealer.toFixed(2));
    return;
  }

  if (field === dealerField) {
    const provvDealer = parseFloat(value);
    const provvSegnalatore = provvDealer * (perc / 100);
    setFieldValue('provvigioniSegnalatore', isNaN(provvSegnalatore) ? '' : provvSegnalatore.toFixed(2));
  }
};
